import { render, staticRenderFns } from "./FakturPajakDetail.vue?vue&type=template&id=45c24f06&scoped=true"
import script from "./FakturPajakDetail.vue?vue&type=script&lang=js"
export * from "./FakturPajakDetail.vue?vue&type=script&lang=js"
import style0 from "./FakturPajakDetail.vue?vue&type=style&index=0&id=45c24f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c24f06",
  null
  
)

export default component.exports